import { Row } from "reactstrap"

const EnvironmentalAuditPreview = props => {
  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td> Legal Status </td>
              <td>{props.data.legal_status}</td>
            </tr>

            <tr>
              <td>Project Title</td>
              <td>{props.data.title_of_project}</td>
            </tr>

            {/* <tr>
              <td>Developer Name</td>
              <td>
                {props.data.developer_name}
              </td>
            </tr>

            <tr>
              <td>Developer Phone</td>
              <td>
                {props.data.developer_phone}
              </td>
            </tr>

            <tr>
              <td>Developer Name</td>
              <td>
                {props.data.developer_name}
              </td>
            </tr>

            <tr>
              <td>Developer Email</td>
              <td>
                {props.data.developer_email}
              </td>
            </tr> */}

            <tr>
              <td>UPI</td>
              <td>{props.data.upi}</td>
            </tr>

          
            <tr>
              <td>Project Province</td>
              <td>{props.data.province}</td>
            </tr>

            <tr>
              <td>Project District</td>
              <td>{props.data.district}</td>
            </tr>

            {/* <tr>
              <td>Developer Name</td>
              <td>
                {props.data.developer_name}
              </td>
            </tr> */}

            <tr>
              <td>Project Sector</td>
              <td>{props.data.sector}</td>
            </tr>

            <tr>
              <td>Project Cell</td>
              <td>{props.data.cell}</td>
            </tr>

            <tr>
              <td>Sector of Activity</td>
              <td>{props.data.sector_of_activity_name}</td>
            </tr>

            <tr>
              <td>Commencement Date</td>
              <td>{props.data.date_of_commencement}</td>
            </tr>

            <tr>
              <td>List of Main Activities</td>
              <td>{props.data.list_of_main_activities}</td>
            </tr>

            <tr>
              <td>Main Raw Materials</td>
              <td>{props.data.list_of_main_raw_materials}</td>
            </tr>

            
            <tr>
              <td>Has Env Impact Assessment been conducted before?</td>
              <td>{props.data.has_eia_conducted_before? "Yes" : "No"}</td>
            </tr>

            <tr>
              <td>Has Env Audit been conducted before?</td>
              <td>{props.data.has_environmental_audit_conducted_before? "Yes" : "No"}</td>
            </tr>

            <tr>
              <td>Zoning of Project</td>
              <td>{props.data.zoning_of_project}</td>
            </tr>


            <tr>
              <td>Activities in Project Zone</td>
              <td>{props.data.main_activities_in_project_zone}</td>
            </tr>

            <tr>
              <td>Key Environmental Impacts</td>
              <td>{props.data.brief_on_key_environemental_impacts}</td>
            </tr>

            
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default EnvironmentalAuditPreview
